import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
var PrintLabelAlerts = function (_a) {
    var error = _a.error;
    switch (error.type) {
        case 'TRYAGAIN':
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base" },
                    "We're sorry. There was a temporary technical error. Please try again shortly. If the issue persists, please call Customer Support at",
                    ' ',
                    React.createElement(Link, { height: "normal", href: "tel:1-800-430-3376" }, "1-800-430-3376"),
                    ".")));
        case 'USED':
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base" },
                    "This shipping label has already been used. Please call Customer Support at",
                    ' ',
                    React.createElement(Link, { height: "normal", href: "tel:1-800-430-3376" }, "1-800-430-3376"),
                    ' ',
                    "if you have questions or need additional help.")));
        case 'EXPIRED':
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base" },
                    "This shipping label has expired. Please call Customer Support at",
                    ' ',
                    React.createElement(Link, { height: "normal", href: "tel:1-800-430-3376" }, "1-800-430-3376"),
                    ' ',
                    "if you have questions or need additional help.")));
        case 'UNKNOWN':
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base" },
                    "We\u2019re sorry. There was a temporary technical error. Please try again shortly. If the problem persists, please call Customer Support at",
                    ' ',
                    React.createElement(Link, { height: "normal", href: "tel:1-800-430-3376" }, "1-800-430-3376"),
                    ".")));
        case 'TEMPORARY':
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base" },
                    "This shipping label cannot be printed at this time. Please call Customer Support at",
                    ' ',
                    React.createElement(Link, { height: "normal", href: "tel:1-800-430-3376" }, "1-800-430-3376"),
                    ' ',
                    "if you have questions or need additional help.")));
        case 'SWITCHEDTOPICKUP':
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base" },
                    "This label is no longer valid as the return is set to be picked up by UPS. Please call Customer Support at",
                    ' ',
                    React.createElement(Link, { height: "normal", href: "tel:1-800-430-3376" }, "1-800-430-3376"),
                    ' ',
                    "if you have questions or need additional help.")));
        default:
            return null;
    }
};
export default PrintLabelAlerts;
